<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';
    import { tooltip } from '@svelte-plugins/tooltips';

    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import JobList from './JobList.svelte';
    import { jobs, mainMenu } from '../../../stores/store';
    import { api, jobs_filter_config } from '../../../stores/api';
    import { app } from '../../../stores/app';
    import { get } from 'svelte/store';
    import { SettingsApi } from '../Settings/SettingsApi';
    import MenuContextJobs from '../MenuDropdown/MenuContextJobs.svelte';
    import MonitActionForSelectedJob from './MonitActionForSelectedJob.svelte';
    import TemplateHeaderTrio from '../../shared/TemplateHeaderTrio.svelte';
    import GeocodingStatusWithProgressBar from '../Import/GeocodingStatusWithProgressBar.svelte';
    import SearchInput from '../../shared/SearchInput.svelte';
    import { filter } from '../../../stores/filter';
    import { features } from '../../shared/Features/features';
    import Opacity from '../../shared/Opacity.svelte';
    import { set } from 'zod';
    import WarningColor from '../../shared/WarningColor.svelte';
    import NoticeColor from '../../shared/NoticeColor.svelte';

    let showMonit: boolean = false;
    let progressPercent: number = 0;

    let pointCounterWrapper: any = null;
    let pointCounterTooltip: {content: string, theme: string} = {content: '', theme: ''};

    onMount(() => {
        $mainMenu.currentPage = 'PageJobs';

        Promise.all([SettingsApi.getFilterConfig(get(api), 'location')])
            .then(response => {
                $jobs_filter_config = response[0];
            })
            .catch(error => {
                console.error('getFilterConfig', error);
            });
    });

    $: showMonit = $jobs.selectMode === 'filtered' || $jobs.selectedOrUnselected.length > 0;

    $: {
        if (progressPercent >= 100) {
            console.log('progressPercent>=100', progressPercent);
            $jobs.forceReload = true;
            $jobs.forceRecount = true;
        }
    }

    $: {
        pointCounterTooltip = {content: '', theme: ''};
        if (!$app.settingsReadonly?.allow_limit_exceeding && $app.settingsReadonly?.max_locations !== null) {
            if ($jobs.countTotal.count >= $app.settingsReadonly?.max_locations) {
                pointCounterWrapper = WarningColor;
                pointCounterTooltip.content = $_('location_limit_exceeded', {values: {limit: $app.settingsReadonly?.max_locations}});
                pointCounterTooltip.theme = 'lastmile-warning-tooltip';
            } else if ($jobs.countTotal.count >= 0.9 * $app.settingsReadonly?.max_locations) {
                pointCounterWrapper = NoticeColor;
                pointCounterTooltip.content = $_('location_limit_approaching', {values: {current: $jobs.countTotal.count, limit: $app.settingsReadonly?.max_locations}});
                pointCounterTooltip.theme = 'lastmile-notice-tooltip';
            } else {
                pointCounterWrapper = Opacity;
                pointCounterTooltip.content = $_('location_limit_safe', {values: {current: $jobs.countTotal.count, limit: $app.settingsReadonly?.max_locations}});
                pointCounterTooltip.theme = 'lastmile-tooltip';
            }
        } else {
            pointCounterWrapper = Opacity;
        }
    }
</script>

<TemplateStandard>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderTrio>
            <div slot="main-header">
                <div
                    style="display: flex; flex-direction: row; column-gap: 6px; align-items: baseline; "
                >
                    <div>{$_('To be completed')}</div>
                    {#if $jobs.countTotal.count}
                        <div style="font-size: 12px;">
                            {#if !$app.settingsReadonly?.allow_limit_exceeding && $app.settingsReadonly?.max_locations !== null}
                                <div style="font-size: 12px; display: flex; gap: 5px;"
                                    use:tooltip={pointCounterTooltip.content ? { content: pointCounterTooltip.content, position: 'bottom', autoPosition: true, theme: pointCounterTooltip.theme, maxWidth: 350 } : null }
                                    on:mouseenter={() => {
                                        setTimeout(() => {
                                            window.dispatchEvent(new Event('resize'));
                                        }, 0);
                                    }}
                                >
                                    <svelte:component this={pointCounterWrapper}>
                                        <div style="display: flex; flex-direction: row; gap: 3px">
                                            {$jobs.countTotal.count} / {$app.settingsReadonly?.max_locations}
                                        </div>
                                    </svelte:component>
                                    {#if pointCounterWrapper === WarningColor}
                                        <span style="display: inline-block; width: 14px; background-color: #e28255; color: #ffffff; border-radius: 9px; text-align: center; font-weight: bold">!</span>
                                    {/if}
                                </div>
                            {:else}
                                <Opacity>({$jobs.countTotal.count})</Opacity>
                            {/if}
                        </div>
                    {/if}
                </div>
            </div>
            <div slot="main-search">
                {#if $features.feature_location_list_design_v1}
                    <GeocodingStatusWithProgressBar
                        bind:progressPercent
                        error=""
                        autoHideWhenInactive={true}
                    />
                {:else}
                    <SearchInput
                        placeholder={$_('City, street, name')}
                        query={$filter.jobsToBeCompleted.quickSearch}
                        onChange={q => {
                            $filter.jobsToBeCompleted.quickSearch = q;
                        }}
                        onKeyup={q => {
                            $filter.jobsToBeCompleted.quickSearch = q;
                        }}
                        debounceTime={200}
                    />
                {/if}
            </div>
            <div slot="main-buttons" style="display:flex; align-items: center; column-gap: 25px;">
                <MenuContextJobs visibleOptions={['upload-file', 'manual-add-job']} />
            </div>
        </TemplateHeaderTrio>
    </div>
    <div slot="content-header"></div>
    <div slot="monit">
        {#if showMonit}
            <div style="position: relative;">
                <MonitActionForSelectedJob />
            </div>
        {/if}
    </div>
    <div slot="content" style="display: flex; flex-direction: column; overflow-y: auto;">
        <!--{#if loading && progressPercent>0}-->
        <!--    <Separator />-->
        <!--    <ProgressBar current={progressPercent} withShadow={true} label="Geocoding" />-->
        <!--{/if}-->
        <JobList
            {showMonit}
            bind:filter={$filter.jobsToBeCompleted}
            onChangeFilter={filter => {
                console.log('filter', filter);
            }}
        />
    </div>
    <div slot="footer"></div>
</TemplateStandard>

<style>
</style>
